/**
 * utility for constructing className strings conditionally.
 * usage is the same as `clsx` lib except we don't support objects.
 * see: https://www.npmjs.com/package/clsx
 * @param args
 */
export function cx(...args: unknown[]) {
  return args
    .flat()
    .filter((x) => typeof x === 'string')
    .join(' ')
    .trim();
}
